import { useEffect, useState, useCallback } from "react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tags, X } from "lucide-react";
import { toast } from "sonner";

export const ServiceTagsCard = () => {
  const { hasPerm } = useAuth();
  const canManage = hasPerm("schedule:manage");
  const [tags, setTags] = useState([]);
  const [name, setName] = useState("");
  const load = useCallback(() => api.get("/service-tags").then((r) => setTags(r.data)).catch(() => setTags([])), []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    const n = name.trim();
    if (!n) return;
    if (tags.some((t) => t.name.toLowerCase() === n.toLowerCase())) { toast.error("Tag already exists"); return; }
    try { await api.post("/service-tags", { name: n }); setName(""); load(); } catch (e) { toast.error(apiError(e)); }
  };
  const remove = async (id) => { try { await api.delete(`/service-tags/${id}`); load(); } catch (e) { toast.error(apiError(e)); } };

  return (
    <div className="border border-border rounded-lg bg-card p-6 mt-6" data-testid="service-tags-card">
      <div className="flex items-center gap-2 mb-1"><Tags className="w-4 h-4 text-brand" /><h2 className="font-heading font-semibold">Service Tags</h2></div>
      <p className="text-sm text-muted-foreground mb-4">Used on customers, schedules and trips (e.g. NMT, Adult Day Support).</p>
      <div className="flex flex-wrap gap-2 mb-4">
        {tags.length === 0 && <span className="text-sm text-muted-foreground">No tags yet.</span>}
        {tags.map((t) => (
          <span key={t.id} className="inline-flex items-center gap-1 rounded-full border border-border px-3 py-1 text-xs font-medium" data-testid="service-tag">
            {t.name}
            {canManage && <button onClick={() => remove(t.id)} aria-label="Remove" data-testid={`service-tag-remove-${t.name}`}><X className="w-3 h-3" /></button>}
          </span>
        ))}
      </div>
      {canManage && (
        <div className="flex gap-2 max-w-sm">
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="New tag" onKeyDown={(e) => e.key === "Enter" && add()} data-testid="service-tag-input" />
          <Button onClick={add} data-testid="service-tag-add">Add</Button>
        </div>
      )}
    </div>
  );
};
